"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";
import { toast } from "sonner";

function isStaleServerActionError(reason: unknown): boolean {
  if (!reason) return false;
  const err = reason as { name?: unknown; message?: unknown; digest?: unknown };
  if (err.name === "UnrecognizedActionError") return true;
  const msg =
    typeof err.message === "string"
      ? err.message
      : typeof err.digest === "string"
        ? err.digest
        : "";
  return /Server Action ".+" was not found on the server/.test(msg);
}

export function ServerActionStaleHandler() {
  const t = useTranslations("system.appUpdated");

  useEffect(() => {
    let reloading = false;

    const handleRejection = (event: PromiseRejectionEvent) => {
      if (!isStaleServerActionError(event.reason)) return;
      event.preventDefault();
      if (reloading) return;
      reloading = true;

      toast.info(t("title"), {
        description: t("description"),
        duration: 1500,
      });

      setTimeout(() => {
        window.location.reload();
      }, 1500);
    };

    window.addEventListener("unhandledrejection", handleRejection);
    return () => {
      window.removeEventListener("unhandledrejection", handleRejection);
    };
  }, [t]);

  return null;
}
